import * as Yup from 'yup';

const validationSchema = (t) => {
  return Yup.object({
    weightValue: Yup.number()
      .min(40.1, t('goalSettings.currentBodyWeight.validation', { limit: 'low' }))
      .max(249.9, t('goalSettings.currentBodyWeight.validation', { limit: 'high' }))
      .when('weightUnit', {
        is: (value) => value && value === 'lb',
        then: (schema) =>
          schema
            .min(88.4, t('goalSettings.currentBodyWeight.validation', { limit: 'low' }))
            .max(550.9, t('goalSettings.currentBodyWeight.validation', { limit: 'high' })),
      }),
    goalWeightValue: Yup.number()
      .min(40.1, t('goalSettings.goalBodyWeight.validation', { min: '40 kg', max: '250 kg' }))
      .max(249.9, t('goalSettings.goalBodyWeight.validation', { min: '40 kg', max: '250 kg' }))
      .when('weightUnit', {
        is: (value) => value && value === 'lb',
        then: (schema) =>
          schema
            .min(
              88.4,
              t('goalSettings.goalBodyWeight.validation', { min: '88.4 lb', max: '551 lb' })
            )
            .max(
              550.9,
              t('goalSettings.goalBodyWeight.validation', { min: '88.4 lb', max: '551 lb' })
            ),
      }),
  });
};

export default validationSchema;
